import SwatchFilter from "../app/components/SwatchFilter";
import { ITab, ITabs } from "../app/types/customizer";
import { getFilterMetaData, getSelectedOption, getWarning } from "./commonRingUtils";

const formatValue = (value: string): string => {
  const numValue = parseFloat(value);
  return !isNaN(numValue) ? numValue.toFixed(2) : value;
};

const getWeightDataByLabel = (product: any, label: string) => {
  return product?.data?.weight_data?.find((item: any) => item.label?.toLowerCase().includes(label.toLowerCase()));
};

export const createVolumeTab = (product: any): ITab | null => {
  const volumeData = getWeightDataByLabel(product, 'net volume');
  if (!volumeData?.value) return null;

  const formattedValue = `${formatValue(volumeData.value)} in³`;

  return {
    title: "Net Volume",
    label: "Net Volume",
    eventKey: "volume",
    component: SwatchFilter,
    isEnabled: true,
    hideFromTabs: true,
    content: {
      hasSwatch: false,
      fieldType: "volume",
      options: [],
      selectedOption: {
        name: formattedValue,
        short_name: formattedValue,
        type: "option",
        swatch_url: "",
        selected: true,
        sku: "",
      },
    },
  };
};

export const createThicknessTab = (product: any): ITab | null => {
  const thicknessData = getWeightDataByLabel(product, 'thickness');
  if (!thicknessData?.value) return null;

  const formattedValue = `${formatValue(thicknessData.value)} mm`;

  return {
    title: "Thickness",
    label: "Thickness",
    eventKey: "thickness",
    component: SwatchFilter,
    isEnabled: true,
    hideFromTabs: true,
    content: {
      hasSwatch: false,
      fieldType: "thickness",
      options: [],
      selectedOption: {
        name: formattedValue,
        short_name: formattedValue,
        type: "option",
        swatch_url: "",
        selected: true,
        sku: "",
      },
    },
  };
};

export const getShapeItems = (product: any) => {
  const items: ITabs = [
    {
      title: "Profile",
      label: "Profile",
      eventKey: "profile",
      component: SwatchFilter,
      isEnabled: product.profile?.length > 0,
      content: {
        // showDefaultTitle: false,
        // displayShowMoreOption: false,
        // meta: getFilterMetaData(product, 'profile'),
        // warning: getWarning(product, 'profile'),
        hasSwatch: true,
        fieldType: "profile",
        options: product.profile,
        selectedOption: getSelectedOption(product.profile),
      },
    },
    {
      title: "Width",
      label: "Width",
      eventKey: "width",
      component: SwatchFilter,
      isEnabled: product.width?.length > 0,
      content: {
        // showDefaultTitle: true,
        // displayShowMoreOption: false,
        // meta: getFilterMetaData(product, 'width'),
        // warning: getWarning(product, 'width'),
        hasSwatch: true,
        fieldType: "width",
        options: product.width,
        selectedOption: getSelectedOption(product.width),
      },
    },
    {
      title: "Weight",
      label: "Weight",
      eventKey: "weight",
      component: SwatchFilter,
      isEnabled: product.weight?.length > 0,
      content: {
        // showDefaultTitle: true,
        // displayShowMoreOption: false,
        // meta: getFilterMetaData(product, 'weight'),
        // warning: getWarning(product, 'weight'),
        hasSwatch: true,
        fieldType: "weight",
        options: product.weight,
        selectedOption: getSelectedOption(product.weight),
      },
    },
  ];

  const filtered = items.filter(
    (tab: ITab) => tab.isEnabled || tab.items?.length
  );
  return filtered;
};

export const getV3ShapeItems = (product: any) => {
  const items: ITabs = [
    {
      title: "Shape",
      label: "Shape",
      eventKey: "signet_shape",
      component: SwatchFilter,
      isEnabled: product.shape?.length > 0,
      content: {
        hasSwatch: true,
        fieldType: "shape",
        options: product.shape,
        selectedOption: getSelectedOption(product.shape),
      },
    },
    {
      title: "Size",
      label: "Size",
      eventKey: "signet_size",
      component: SwatchFilter,
      isEnabled: product.size?.length > 0,
      content: {
        hasSwatch: true,
        fieldType: "size",
        options: product.size,
        selectedOption: getSelectedOption(product.size),
      },
    },
    {
      title: "Shank",
      label: "Shank",
      eventKey: "signet_shank",
      component: SwatchFilter,
      isEnabled: product.shank?.length > 0,
      content: {
        hasSwatch: true,
        fieldType: "shank",
        options: product.shank,
        selectedOption: getSelectedOption(product.shank),
      },
    },
    {
      title: "Weight",
      label: "Weight",
      eventKey: "signet_weight",
      component: SwatchFilter,
      isEnabled: product.weight?.length > 0,
      content: {
        hasSwatch: true,
        fieldType: "weight",
        options: product.weight,
        selectedOption: getSelectedOption(product.weight),
      },
    },
  ];
 
  const filtered = items.filter(
    (tab: ITab) => tab.isEnabled || tab.items?.length
  );
  return filtered;
};
